<template>
  <div>
    <ContentHeader :show-back="false" />
    <div class="content-container">
      <div class="container">
        <el-card>
          <div class="el-icon-circle-check"></div>
          <div class="order-success-title">订单提交成功</div>
          <div class="order-success-code">订单编号：{{ number }}</div>
          <el-button type="danger" class="to-index-btn" @click="goToView"
            >进入管理页面</el-button
          >
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
export default {
  name: 'stock-order-success',
  components: {
    ContentHeader
  },
  data () {
    return {
      number: '',
      path: '',
      moduleType: '' // 01库存；02配额; 03申请；04金额
    }
  },
  created () {
    this.moduleType = this.$route.query.moduleType
    this.number = this.$route.query.successNumber
    this.init()
  },
  methods: {
    init () {
      switch (this.moduleType) {
        case '01':
          this.path = '/stock/stock'
          break
        case '02':
          this.path = '/stock/quota'
          break
        case '03':
          this.path = '/stock/apply'
          break
        case '04':
          this.path = '/stock/money'
          break
      }
    },
    goToView () {
      this.$router.push({
        path: this.path
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  font-size: 24px;
  color: $base-black;
  .el-card {
    width: 100%;
    height: 300px;
    text-align: center;
    .el-icon-circle-check {
      line-height: 100px;
      font-size: 50px;
      color: $base-red;
    }
    .order-success-title {
      padding-bottom: 10px;
    }
    .order-success-code {
      font-size: 14px;
      color: #666;
    }
    .el-button {
      margin-right: 10px;
      margin-top: 30px;
    }
  }
}
</style>
